import React, { useContext } from "react";

import PropTypes from "prop-types";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useInfo } from "utils/hooks/info";

import { StoreContext } from "../../shared/store";
import { PATHS } from "../../utils/constants";

const ALLOWED_UNKNOWN_ROUTES = [
  PATHS.FILE.CONTACT_US_NOTIFICATION,
  PATHS.FILE.CONTACTUS,
  PATHS.ACCOUNT,
];

const PrivateRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const { loggedIn } = useContext(StoreContext);
  const { commonInfo } = useInfo();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!loggedIn) {
          return <Redirect to={PATHS.AUTH.SIGN_IN} />;
        }
        if (
          commonInfo.knownCustomer === false &&
          !ALLOWED_UNKNOWN_ROUTES.includes(location.pathname)
        ) {
          return <Redirect to={PATHS.FILE.CONTACT_US_NOTIFICATION} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.node.isRequired,
};

export default PrivateRoute;
